module.exports = "/_next/static/images/c15720b7a91b486afb1ef897ed2894f4-hands-holding-cards-md@1x.jpg.webp";